import React, {useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {identity, isEmpty} from "@pg-mono/nodash";

import {ResponsiveTableRow} from "../../../atoms/ResponsiveTableRow";

interface IProps {
    onExpand?: () => void;
    standardDescription: IStandardDescription;
    types: {
        value: number;
        label: string;
    }[];
    showOnlyTurnkeyStandard?: boolean;
}

export interface IStandardDescription {
    types: number[];
    description: string | null;
    building_structure: string | null;
    roof: string | null;
    facade: string | null;
    windows: string | null;
    exterior_doors: string | null;
    balconies: string | null;
    flooring: string | null;
    walls: string | null;
    ceilings: string | null;
    exterior_sills: string | null;
    interior_sills: string | null;
    installations: string | null;
    heating: string | null;
    ventilation: string | null;
    bathroom_equipment: string | null;
    kitchen_equipment: string | null;
}

export const defaultStandardDescription: IStandardDescription = {
    types: [],
    description: null,
    building_structure: null,
    roof: null,
    facade: null,
    windows: null,
    exterior_doors: null,
    balconies: null,
    flooring: null,
    walls: null,
    ceilings: null,
    exterior_sills: null,
    interior_sills: null,
    installations: null,
    heating: null,
    ventilation: null,
    bathroom_equipment: null,
    kitchen_equipment: null
};

const translatedStandardDescriptionDict: Record<string, string> = {
    building_structure: "Konstrukcja budynku",
    roof: "Dach",
    facade: "Elewacja",
    windows: "Stolarka okienna",
    exterior_doors: "Drzwi zewnętrzne",
    balconies: "Balkony",
    flooring: "Posadzka",
    walls: "Ściany",
    ceilings: "Sufity",
    exterior_sills: "Parapety zewnętrzne",
    interior_sills: "Parapety wewnętrzne",
    installations: "Instalacje",
    heating: "Ogrzewanie",
    ventilation: "Wentylacja",
    bathroom_equipment: "Wyposażenie łazienki",
    kitchen_equipment: "Wyposażenie kuchni"
};

const translateStandardDescriptionKey = (key: keyof IStandardDescription) => {
    return key in translatedStandardDescriptionDict ? translatedStandardDescriptionDict[key] : null;
};

export const OfferStandardDescription: React.FunctionComponent<IProps> = (props) => {
    const {standardDescription, showOnlyTurnkeyStandard} = props;

    const [showContent, setShowContent] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {types, description, ...standardFields} = standardDescription;
    const foundStandardDescription = props.standardDescription.types.map((sD) => props.types?.find((sDT) => sDT.value === sD));
    const standardDescriptionList = foundStandardDescription
        .map((item) => (item && item.label.toLowerCase()) || "")
        .filter(identity)
        .join(", ");
    const hasStandardFieldsValues = Object.entries(standardFields || {}).find(
        ([key, field]) => !isEmpty(field) && translateStandardDescriptionKey(key as keyof IStandardDescription)
    );

    const showStandardDescriptionContent = () => {
        props.onExpand?.();
        setShowContent(true);
    };

    const renderStandardDescriptionContent = () =>
        Object.entries(standardFields).map(([key, value]) => {
            const translatedKey = translateStandardDescriptionKey(key as keyof IStandardDescription);
            if (!isEmpty(value) && translatedKey) {
                return (
                    <div key={key}>
                        <Text variant="body_copy_2" className={smallTextHeadingStyle}>
                            {translateStandardDescriptionKey(key as keyof IStandardDescription)}
                        </Text>

                        <Text variant="body_copy_2">{value}</Text>
                    </div>
                );
            }
        });

    const renderDescriptionText = () => {
        return (
            <>
                <div>
                    <Text variant="body_copy_2" className={standardDescriptionListStyle}>
                        {showOnlyTurnkeyStandard ? "wykończenie pod klucz" : standardDescriptionList}
                    </Text>

                    {description ? (
                        <Text variant="body_copy_2" as="div">
                            {description}
                        </Text>
                    ) : (
                        ""
                    )}

                    {hasStandardFieldsValues && !showContent && (
                        <Button
                            className={detailsButtonStyle}
                            data-gtm-click="Czytaj więcej - standard wykończenia"
                            variant="highlight_primary"
                            onClick={showStandardDescriptionContent}
                        >
                            <Text variant="button_micro">Czytaj więcej</Text>
                        </Button>
                    )}
                </div>

                <div className={showContent ? showStyle : hideStyle}>
                    <div>
                        {renderStandardDescriptionContent()}

                        {hasStandardFieldsValues && showContent && (
                            <Button
                                className={detailsButtonStyle}
                                data-gtm-click="Czytaj mniej - standard wykończenia"
                                variant="highlight_primary"
                                onClick={() => setShowContent(false)}
                            >
                                <Text variant="button_micro">Czytaj mniej</Text>
                            </Button>
                        )}
                    </div>
                </div>
            </>
        );
    };

    return <ResponsiveTableRow title="Standard wykończenia">{renderDescriptionText()}</ResponsiveTableRow>;
};

const standardDescriptionListStyle = css({
    "&:not(:last-of-type)": {
        marginBottom: "2rem"
    }
});

const showStyle = css({
    display: "block"
});

const hideStyle = css({
    display: "none"
});

const detailsButtonStyle = css({
    marginTop: 2
});

const smallTextHeadingStyle = css({
    fontWeight: "bold",
    marginTop: "1rem",
    marginRight: 0,
    marginBottom: "1rem",
    marginLeft: 0
});
import React, {useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {identity, isEmpty} from "@pg-mono/nodash";

import {ResponsiveTableRow} from "../../../atoms/ResponsiveTableRow";

interface IProps {
    onExpand?: () => void;
    standardDescription: IStandardDescription;
    types: {
        value: number;
        label: string;
    }[];
    showOnlyTurnkeyStandard?: boolean;
}

export interface IStandardDescription {
    types: number[];
    description: string | null;
    building_structure: string | null;
    roof: string | null;
    facade: string | null;
    windows: string | null;
    exterior_doors: string | null;
    balconies: string | null;
    flooring: string | null;
    walls: string | null;
    ceilings: string | null;
    exterior_sills: string | null;
    interior_sills: string | null;
    installations: string | null;
    heating: string | null;
    ventilation: string | null;
    bathroom_equipment: string | null;
    kitchen_equipment: string | null;
}

export const defaultStandardDescription: IStandardDescription = {
    types: [],
    description: null,
    building_structure: null,
    roof: null,
    facade: null,
    windows: null,
    exterior_doors: null,
    balconies: null,
    flooring: null,
    walls: null,
    ceilings: null,
    exterior_sills: null,
    interior_sills: null,
    installations: null,
    heating: null,
    ventilation: null,
    bathroom_equipment: null,
    kitchen_equipment: null
};

const translatedStandardDescriptionDict: Record<string, string> = {
    building_structure: "Konstrukcja budynku",
    roof: "Dach",
    facade: "Elewacja",
    windows: "Stolarka okienna",
    exterior_doors: "Drzwi zewnętrzne",
    balconies: "Balkony",
    flooring: "Posadzka",
    walls: "Ściany",
    ceilings: "Sufity",
    exterior_sills: "Parapety zewnętrzne",
    interior_sills: "Parapety wewnętrzne",
    installations: "Instalacje",
    heating: "Ogrzewanie",
    ventilation: "Wentylacja",
    bathroom_equipment: "Wyposażenie łazienki",
    kitchen_equipment: "Wyposażenie kuchni"
};

const translateStandardDescriptionKey = (key: keyof IStandardDescription) => {
    return key in translatedStandardDescriptionDict ? translatedStandardDescriptionDict[key] : null;
};

export const OfferStandardDescription: React.FunctionComponent<IProps> = (props) => {
    const {standardDescription, showOnlyTurnkeyStandard} = props;

    const [showContent, setShowContent] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {types, description, ...standardFields} = standardDescription;
    const foundStandardDescription = props.standardDescription.types.map((sD) => props.types?.find((sDT) => sDT.value === sD));
    const standardDescriptionList = foundStandardDescription
        .map((item) => (item && item.label.toLowerCase()) || "")
        .filter(identity)
        .join(", ");
    const hasStandardFieldsValues = Object.entries(standardFields || {}).find(
        ([key, field]) => !isEmpty(field) && translateStandardDescriptionKey(key as keyof IStandardDescription)
    );

    const showStandardDescriptionContent = () => {
        props.onExpand?.();
        setShowContent(true);
    };

    const renderStandardDescriptionContent = () =>
        Object.entries(standardFields).map(([key, value]) => {
            const translatedKey = translateStandardDescriptionKey(key as keyof IStandardDescription);
            if (!isEmpty(value) && translatedKey) {
                return (
                    <div key={key}>
                        <Text variant="body_copy_2" className={smallTextHeadingStyle}>
                            {translateStandardDescriptionKey(key as keyof IStandardDescription)}
                        </Text>

                        <Text variant="body_copy_2">{value}</Text>
                    </div>
                );
            }
        });

    const renderDescriptionText = () => {
        return (
            <>
                <div>
                    <Text variant="body_copy_2" className={standardDescriptionListStyle}>
                        {showOnlyTurnkeyStandard ? "wykończenie pod klucz" : standardDescriptionList}
                    </Text>

                    {description ? (
                        <Text variant="body_copy_2" as="div">
                            {description}
                        </Text>
                    ) : (
                        ""
                    )}

                    {hasStandardFieldsValues && !showContent && (
                        <Button
                            className={detailsButtonStyle}
                            data-gtm-click="Czytaj więcej - standard wykończenia"
                            variant="highlight_primary"
                            onClick={showStandardDescriptionContent}
                        >
                            <Text variant="button_micro">Czytaj więcej</Text>
                        </Button>
                    )}
                </div>

                <div className={showContent ? showStyle : hideStyle}>
                    <div>
                        {renderStandardDescriptionContent()}

                        {hasStandardFieldsValues && showContent && (
                            <Button
                                className={detailsButtonStyle}
                                data-gtm-click="Czytaj mniej - standard wykończenia"
                                variant="highlight_primary"
                                onClick={() => setShowContent(false)}
                            >
                                <Text variant="button_micro">Czytaj mniej</Text>
                            </Button>
                        )}
                    </div>
                </div>
            </>
        );
    };

    return <ResponsiveTableRow title="Standard wykończenia">{renderDescriptionText()}</ResponsiveTableRow>;
};

const standardDescriptionListStyle = css({
    "&:not(:last-of-type)": {
        marginBottom: "2rem"
    }
});

const showStyle = css({
    display: "block"
});

const hideStyle = css({
    display: "none"
});

const detailsButtonStyle = css({
    marginTop: 2
});

const smallTextHeadingStyle = css({
    fontWeight: "bold",
    marginTop: "1rem",
    marginRight: 0,
    marginBottom: "1rem",
    marginLeft: 0
});
